import { useMemo } from 'react'
import { FIRST_DATE_TS, NOW_TS } from '../configs/config'

import * as ethers from 'ethers'
import { e30 } from '../helpers'

import { useGraph, tokenSymbols } from '../dataProvider'

const { JsonRpcProvider } = ethers.providers

export function useTokenVolumeData({
  from = FIRST_DATE_TS,
  to = NOW_TS,
  chainName = 'polygon',
} = {}) {
  const queryStr = (_from, _to) => `
  tokenVolumeStats(
    first:1000
    skip:0
    orderBy:timestamp
    orderDirection:desc,
    where: { period: daily, timestamp_gte: ${_from}, timestamp_lte: ${_to}}
    ){
    id
    timestamp
    token
    totalMargin
    }
  `

  const calculateFrom = (to, period) => {
    const day = 86400
    const _from = from
    if (period === 'daily') {
      return to - day
    }
    if (period === 'weekly') {
      return to - 7 * day
    }
    if (period === 'monthly') {
      return to - 30 * day
    }
    if (period === 'total') {
      return _from
    }
    throw new Error('Not supported Period')
  }

  const query = `{
        daily:${queryStr(calculateFrom(to, 'daily'), to)},
        weekly:${queryStr(calculateFrom(to, 'weekly'), to)},
        monthly:${queryStr(calculateFrom(to, 'monthly'), to)},
        total:tokenVolumeStats(
          first:1000
          skip:0
          orderBy:timestamp
          orderDirection:desc,
          where: { period: total}
          ){
          id
          timestamp
          token
          totalMargin
          }
    }`

  const [graphData, loading, error] = useGraph(query, { chainName })

  const data = useMemo(() => {
    if (!graphData || loading) return

    return Object.keys(graphData).reduce((accum, period) => {
      let sumOfEachPeriod = 0
      const _periodDatas = graphData[period]
        .filter((i) => {
          return i.totalMargin !== '0'
        })
        .map((myData) => {
          const value = parseInt(myData.totalMargin) / e30
          sumOfEachPeriod += value
          return {
            name: tokenSymbols[myData.token],
            value: value,
            start: calculateFrom(to, period),
            end: to,
          }
        })
        .reduce((tokenAccumData, each) => {
          const tokenData = tokenAccumData.find((i) => i.name === each.name)
          return [
            ...tokenAccumData.filter((i) => i.name !== each.name),
            !!tokenData
              ? {
                  ...tokenData,
                  value: tokenData.value + each.value,
                }
              : {
                  ...each,
                  totalVolume: sumOfEachPeriod,
                },
          ]
        }, [])

      return {
        ...accum,
        [period]: _periodDatas,
      }
    }, {})
  }, [graphData, loading])

  return [data, loading, error]
}
